import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { watchHardwareKeyboard } from "./lib/input-mode.js";
import { isNative } from "./platform/native.js";
import { initNativeShell } from "./platform/shell.js";
import { createAppRouter } from "./router.js";
import "./styles.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false },
    // spec11 FR14: a change without a connection fails at once with a clear message instead
    // of waiting (paused) until the connection is back.
    mutations: { networkMode: "always" },
  },
});
const router = createAppRouter(queryClient);
watchHardwareKeyboard();
if (isNative) void initNativeShell(queryClient);

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root element");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
